// types
import { FlagCode } from '../../../@types';
import { flagCodes } from '../../../@types/unions';

// mui
import { Box } from '@mui/material';

// props
export interface FlagProps {
	code: FlagCode;
}

export const Flag = ({ code }: FlagProps) => {
	if (!flagCodes.includes(code)) {
		return <></>;
	}

	return (
		<Box
			component="span"
			sx={{
				'& img': {
					display: 'block',
					width: 'auto',
					height: 18,
				},
			}}>
			<img alt={code} src={`/img/flags/${code.toLowerCase()}.svg`} />
		</Box>
	);
};
